<template src="./DrawerActivity.html" />
<script>
import generateSignalPatternList from '../../../utils/generateSignalPatternList';
/**
 * お気に入り銘柄 ドロワー アクティビティ
 * @vue-prop {Object} item
 * @module Mypage/Drawer/DrawerActivity
 */

export default {
  name: 'DrawerActivity',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    activities() {
      return this.$store.getters['favoriteFinancialItemDetails/detailsActivities'](this.item.code);
    },
  },
  methods: {
    /**
     * シグナルのパターンごとにクラス名とテキストを返す
     * @param {string} title
     * @return {Array}
     */
    signalPattern(title) {
      return generateSignalPatternList(title);
    },
  },
};
</script>
